import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TripUseCase } from '../../services/trip-flow.service';
import { modules } from '../../shared/order.module';
import { TranslateModule } from '@ngx-translate/core';

export interface TripFlowDialogData {
  retailers: any[];
}

export interface TripFlowDialogResult {
  useCase: TripUseCase;
  retailer?: any;
}

@Component({
  selector: 'app-trip-flow-dialog',
  standalone: true,
  imports: [...modules, TranslateModule],
  templateUrl: './trip-flow-dialog.component.html',
  styleUrls: ['./trip-flow-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripFlowDialogComponent implements OnInit {
  step: 'usecase' | 'airport' = 'usecase';
  selectedUseCase: TripUseCase | null = null;
  retailers: any[] = [];

  readonly useCases = [
    {
      id: 1 as TripUseCase,
      titleKey: 'TRIP_FLOW.CASE_1_TITLE',
      subtitleKey: 'TRIP_FLOW.CASE_1_SUBTITLE',
      icon: 'flight_land',
      accentColor: '#F4BE00',
    },
    {
      id: 2 as TripUseCase,
      titleKey: 'TRIP_FLOW.CASE_2_TITLE',
      subtitleKey: 'TRIP_FLOW.CASE_2_SUBTITLE',
      icon: 'flight_takeoff',
      accentColor: '#F4BE00',
    },
    {
      id: 3 as TripUseCase,
      titleKey: 'TRIP_FLOW.CASE_3_TITLE',
      subtitleKey: 'TRIP_FLOW.CASE_3_SUBTITLE',
      icon: 'location_city',
      accentColor: '#F4BE00',
    },
  ];

  constructor(
    private _cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<TripFlowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TripFlowDialogData
  ) {
    this.retailers = data?.retailers ?? [];
  }

  ngOnInit(): void {}

  selectUseCase(useCase: TripUseCase): void {
    this.selectedUseCase = useCase;
    if (useCase === 3) {
      this.dialogRef.close({ useCase: 3 } as TripFlowDialogResult);
      return;
    }
    this.step = 'airport';
    this._cdr.markForCheck();
  }

  selectRetailer(retailer: any): void {
    if (!this.selectedUseCase) return;
    this.dialogRef.close({ useCase: this.selectedUseCase, retailer } as TripFlowDialogResult);
  }

  goBack(): void {
    this.step = 'usecase';
    this.selectedUseCase = null;
    this._cdr.markForCheck();
  }

  skip(): void {
    this.dialogRef.close(null);
  }
}
